<ion-item *ngIf="commentsEnabled" class="ion-text-wrap" (click)="showComments($event)" [detail]="true" button>
    <ion-label>
        <h2>{{plugin.name}}</h2>
        <core-comments contextLevel="module" [instanceId]="assign.cmid" component="assignsubmission_comments" [itemId]="submission.id"
            area="submission_comments" [title]="plugin.name" [courseId]="assign.course" />
    </ion-label>
</ion-item>
